/* src/app/result/reflection/reflection.component.scss */
.page {
  width: 1180px;
  height: 620px;
  border-radius: 20px;
  background-color: #3D3F47;
  margin: 0 auto;
  padding: 50px;
  justify-content: center;
}
.page .page-counter {
  margin-bottom: 30px;
}
.page.reflection-intro {
  display: flex;
}
.page.reflection-intro .text {
  padding-right: 100px;
  min-width: 700px;
}
.page.reflection-intro .text h1 {
  font-size: 50px;
  font-weight: 700;
  line-height: 50px;
  margin-bottom: 50px;
}
.page .text {
  font-family: "Campton-Light";
  text-align: left;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 30px;
}
.page .text h1 {
  font-family: "Campton-Light";
  font-size: 34px;
  font-style: normal;
  font-weight: 400;
  line-height: 46px;
}
.page .text h1.bold {
  font-family: "Campton-bold";
}
.page .image {
  border-radius: 20px;
  width: 380px;
  height: 520px;
}
.page .question-area textarea {
  margin-top: 20px;
  width: 100%;
  height: 340px;
  border-radius: 20px;
  border: 1px solid #d9d9d9;
  resize: none;
  padding: 20px;
  font-size: 20px;
}
.buttons {
  width: 1180px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  margin-top: 30px;
}
.buttons.only-next {
  justify-content: right;
}
.buttons.only-start {
  justify-content: right;
}
.buttons.only-back {
  justify-content: start;
}
/*# sourceMappingURL=reflection.component.css.map */
